import { makeImmutable } from "../../core";
export class CompositePackagingFeeRequirement {
    constructor(requirements) {
        this.requirements = requirements;
        makeImmutable(this);
    }
    testProduct(productInstance) {
        return this.requirements.some((requirement) => requirement.testProduct(productInstance));
    }
    testModifier(modifierInstance, modifierItemTypeId) {
        return this.requirements.some((requirement) => requirement.testModifier(modifierInstance, modifierItemTypeId));
    }
}
